import styled, { css } from 'styled-components';
import { size } from '../../layout/helpers';

interface WrapperProps {
  $tone?: 'info' | 'success' | 'warning' | 'error';
  $limitHeight?: boolean;
}

export const Wrapper = styled.div<WrapperProps>`
--info-box-bg: var(--c-semantic-info-100);
--info-box-fg: var(--c-semantic-info-700);
--info-box-border: var(--c-semantic-info-500);

  padding: ${size(2)};
  border-radius: ${size(1)};
  background-color: var(--info-box-bg);
  color: var(--info-box-fg);
  border: 1px dashed var(--info-box-border);
  font-size: ${(props) => props.theme.font.size.small};
  white-space: pre-line;

  > *:first-child {
    margin-top: 0;
  }

  > *:last-child {
    margin-bottom: 0;
  }

  ${({ $limitHeight }) =>
    $limitHeight &&
    css`
      max-height: ${size(30)};
      overflow-y: auto;
    `}

  ${({ $tone }) =>
    $tone === 'info'
      ? css`
          --info-box-bg: var(--c-semantic-info-100);
          --info-box-fg: var(--c-semantic-info-700);
          --info-box-border: var(--c-semantic-info-500);
        `
      : $tone === 'success'
        ? css`
            --info-box-bg: var(--c-semantic-success-100);
            --info-box-fg: var(--c-semantic-success-700);
            --info-box-border: var(--c-semantic-success-500);
          `
        : $tone === 'warning'
          ? css`
              --info-box-bg: var(--c-semantic-warning-100);
              --info-box-fg: var(--c-semantic-warning-700);
              --info-box-border: var(--c-semantic-warning-500);
            `
          : $tone === 'error'
            ? css`
                  --info-box-bg: var(--c-semantic-error-100);
                  --info-box-fg: var(--c-semantic-error-700);
                  --info-box-border: var(--c-semantic-error-500);
                `
            : undefined}
`;
